import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class LogisticRouteTagsApi extends ApiModule {
	constructor() {
		super(ModulesMap.LOGISTIC_ROUTE_TAGS, {
			entity: 'logistic_route_tags',
		})
	}
}
